import { GoogleRecaptchaScriptFactory } from 'common/module/google/recaptcha/script.factory';

const service = GoogleRecaptchaScriptFactory();

export const GoogleRecaptchaScriptService = () => service;
